import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginComponent } from './login/login.component';
import { AuthRoutingModule } from './auth-routing.module';
import { IonicModule } from '@ionic/angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './auth-interceptor.service';
import { SharedModule } from '../shared/shared.module';
import { TutorialComponent } from './tutorial/tutorial.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LoginComponent,TutorialComponent],
  imports: [
    AuthRoutingModule,
    IonicModule,
    FormsModule,
    CommonModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ]
})
export class AuthModule { }
